@if (!embedded) {
<div class="d-flex justify-content-between align-items-center mb-3">
  <h1 class="mb-0 text-center w-100">Application Settings</h1>
</div>
}

<app-spinner [isLoading]="saving" diameter="50" loadingText="Saving application settings..."></app-spinner>

@if (loading) {
<div class="card">
  <div class="card-body py-4 text-center">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
</div>
}

@if (!loading) {
@if (error) {
<div class="alert alert-danger">
  <mat-icon>error_outline</mat-icon>
  {{ error }}
</div>
}

@if (successMessage) {
<div class="alert alert-success">
  <mat-icon>check_circle</mat-icon>
  {{ successMessage }}
</div>
}

<div class="card">
  <div class="card-body">
    <div class="d-flex justify-content-between align-items-start mb-3 section-header">
      <div>
        <h4 class="card-title mb-1">ADO Settings</h4>
        <p class="text-muted mb-0">These values control the Azure DevOps work items created from application assignment actions.</p>
      </div>
      @if (updatedAtUtc) {
      <small class="text-muted">Last updated: {{ updatedAtUtc | date:'medium' }}</small>
      }
    </div>

    <form [formGroup]="form" (ngSubmit)="save()">
      <div class="row">
        <div class="col-md-6 mb-3">
          <label class="form-label">Organization</label>
          <input class="form-control" formControlName="organization" placeholder="chevron" />
          @if (form.controls.organization.touched && form.controls.organization.invalid) {
          <small class="text-danger">Organization is required.</small>
          }
        </div>

        <div class="col-md-6 mb-3">
          <label class="form-label">Project</label>
          <input class="form-control" formControlName="project" placeholder="ITF-AIModernizationEvaluator" />
          @if (form.controls.project.touched && form.controls.project.invalid) {
          <small class="text-danger">Project is required.</small>
          }
        </div>

        <div class="col-md-6 mb-3">
          <label class="form-label">Work Item Title Prefix</label>
          <input class="form-control" formControlName="workItemTitlePrefix" placeholder="[AI Evaluator - TEST]" />
        </div>

        <div class="col-md-6 mb-3">
          <label class="form-label">Parent Work Item ID</label>
          <input class="form-control" type="number" formControlName="parentWorkItemId" placeholder="9413183" />
          @if (form.controls.parentWorkItemId.touched && form.controls.parentWorkItemId.invalid) {
          <small class="text-danger">Parent Work Item ID must be greater than 0.</small>
          }
        </div>
      </div>

      <div class="d-flex justify-content-end">
        <button class="btn btn-primary no-arrow" type="submit" [disabled]="saving || loading">Save</button>
      </div>
    </form>
  </div>
</div>
}